export default  {"src":"/_next/static/image/public/assets/icons/right-arrow-black.da2c718424276845621f33e8c92dfd13.svg","height":30,"width":17};